// Editorial-quality industrial + sustainability photography with consistent color grading
const IMG = {
  // Metals (local, high-quality photos supplied by client)
  shredded: "/products/shredded-steel.png",
  turning: "/products/steel-turning.png",
  motor: "/products/electric-motor.png",
  compressor: "/products/fridge-compressor.png",
  aluminum: "/products/aluminium-scrap.png",
  hms: "/products/heavy-melting.png",
  plate: "/products/plate-structure.png",
  wireScrap: "/products/tyre-wire.png",
  lms: "/products/light-melting.png",
  ss304: "/products/stainless-steel.png",
  ss316: "/products/stainless-steel.png",
  ss430: "/products/stainless-steel.png",
  hrc: "/products/hot-rolled-coil.png",
  crc: "/products/cold-rolled-coil.png",
  hdg: "/products/hdg-coil.png",
  wireRod: "/products/wire-rod-scrap.png",
  castIron: "/products/cast-iron.png",
  giSheet: "/products/gi-sheet.png",
  copper: "/products/copper.png",
  brass: "/products/brass.png",
  steelCoils: "/products/steel-coils.png",
  metalsHero: "https://images.unsplash.com/photo-1697698532634-ea59b636ccea?auto=format&fit=crop&w=1200&q=80",

  // Rubber
  conveyorTextile: "/products/textile-belt.png",
  conveyorSteel: "/products/steel-cord-belt.png",
  conveyorGeneric: "/products/conveyor-belt.png",
  conveyorPvc: "/products/pvc-belt.png",
  baledTyres: "/products/baled-tyres.png",
  crumbRubber: "/products/crumb-rubber.png",
  rubberHero: "/products/conveyor-belt.png",

  // Others
  heavyMachinery: "/products/heavy-machinery.png",
  generator: "/products/industrial-generators.png",
  eotCrane: "/products/eot-crane.png",
  gantryCrane: "/products/gantry-crane.png",
  wharfCrane: "/products/wharf-crane.png",
  othersHero: "/products/heavy-machinery.png",
};

export const PRODUCT_CATEGORIES = [
  {
    id: "metals",
    name: "Metals",
    tagline: "Ferrous, stainless & non-ferrous metal recycling from Indian industries",
    accent: "#12355B",
    image: IMG.metalsHero,
    intro: "R K STEEL procures and processes a comprehensive range of ferrous scrap, stainless steel scrap, non-ferrous scrap, steel coils, cast iron, galvanized materials and reusable industrial metals — helping industries recover value while advancing sustainable manufacturing.",
    subCategories: ["Ferrous Scrap", "Stainless Steel Scrap", "Non-Ferrous Scrap", "Industrial Steel Products"],
    products: [
      { id: "shredded-steel", name: "Shredded Steel Scrap", image: IMG.shredded, desc: "Baled and shredded ferrous scrap ready for induction furnaces." },
      { id: "steel-turning", name: "Steel Turning Scrap", image: IMG.turning, desc: "Machining turnings recovered from precision engineering." },
      { id: "hms", name: "Heavy Melting Scrap", image: IMG.hms, desc: "HMS 1 & 2 sorted for steelmaking and re-rolling." },
      { id: "plate-structure", name: "Plate & Structure Scrap", image: IMG.plate, desc: "Structural cut-offs from fabrication and demolition projects." },
      { id: "tyre-wire", name: "Steel Tyre Wire Scrap", image: IMG.wireScrap, desc: "Steel wire recovered from end-of-life tyres." },
      { id: "lms", name: "Light Melting Scrap", image: IMG.lms, desc: "Light gauge ferrous scrap sorted by density." },
      { id: "electric-motor", name: "Electric Motor Scrap", image: IMG.motor, desc: "End-of-life motors recycled for copper and steel." },
      { id: "fridge-compressor", name: "Compressor Scrap", image: IMG.compressor, desc: "Recovered compressors from refrigeration industries." },
      { id: "aluminium-scrap", name: "Aluminium Scrap", image: IMG.aluminum, desc: "Sorted aluminium for smelters and extruders." },
      { id: "stainless-steel", name: "Stainless Steel", image: IMG.ss304, desc: "Stainless steel scrap across 304, 316 & 430 grades." },
      { id: "hot-rolled-coil", name: "Hot Rolled Coil", image: IMG.hrc, desc: "HRC for structural fabrication and heavy engineering." },
      { id: "cold-rolled-coil", name: "Cold Rolled Coil", image: IMG.crc, desc: "CRC with superior finish for premium applications." },
      { id: "hdg-coil", name: "Hot Dip Galvanised Coil", image: IMG.hdg, desc: "Zinc-coated coil for corrosion-resistant applications." },
      { id: "wire-rod-scrap", name: "Wire Rod Scrap", image: IMG.wireRod, desc: "Wire rod off-cuts sorted for re-rolling." },
      { id: "cast-iron", name: "Cast Iron", image: IMG.castIron, desc: "Cast iron for foundries and re-melters." },
      { id: "gi-sheet", name: "GI Sheet (Galvanised Iron Sheet)", image: IMG.giSheet, desc: "Galvanised iron sheeting for construction and cladding." },
      { id: "steel-coils", name: "Steel Coils", image: IMG.steelCoils, desc: "Full portfolio of hot, cold and galvanised steel coils." },
      { id: "copper", name: "Copper", image: IMG.copper, desc: "High-purity copper for electrical and alloying." },
      { id: "brass", name: "Brass", image: IMG.brass, desc: "Brass scrap and stock for foundries and workshops." },
    ],
  },
  {
    id: "rubber",
    name: "Rubber",
    tagline: "Stock-lot conveyor belts & industrial rubber materials",
    accent: "#2F9E44",
    image: IMG.rubberHero,
    intro: "R K STEEL is one of India's leading importers and procurement partners for stock-lot conveyor belts and industrial rubber materials. Our vision is to help industries worldwide divert valuable rubber products from landfill by promoting responsible reuse, recycling and sustainable recovery.",
    subCategories: ["Conveyor Belts", "Baled Tyres", "Crumb Rubber"],
    products: [
      { id: "conveyor-belt", name: "Conveyor Belt", image: IMG.conveyorGeneric, desc: "Stock-lot industrial conveyor belts across specifications." },
      { id: "steel-cord-belt", name: "Steel Cord / Reinforced Conveyor Belt", image: IMG.conveyorSteel, desc: "High-tensile steel-cord belts for heavy-duty conveying." },
      { id: "textile-belt", name: "Textile Conveyor Belt Reinforced with Steel Cord", image: IMG.conveyorTextile, desc: "Fabric belts reinforced with steel cord for hybrid strength." },
      { id: "pvc-belt", name: "PVC Belt", image: IMG.conveyorPvc, desc: "PVC belting for food, packaging and light industry." },
      { id: "baled-tyres", name: "Baled Tyres", image: IMG.baledTyres, desc: "End-of-life tyres baled for reuse and pyrolysis." },
      { id: "crumb-rubber", name: "Crumb Rubber", image: IMG.crumbRubber, desc: "Recycled crumb rubber for surfaces and compounds." },
    ],
  },
  {
    id: "others",
    name: "Others",
    tagline: "Used heavy industrial machinery & engineering assets",
    accent: "#B8823E",
    image: IMG.othersHero,
    intro: "R K STEEL procures used heavy industrial machinery and engineering assets from thermal power plants, steel plants, mining operations, cement manufacturing facilities, natural stone cutting industries and other large-scale industrial sectors.",
    subCategories: ["Heavy Machinery", "Cranes & Lifting", "Power & Utilities"],
    products: [
      { id: "heavy-machinery", name: "Heavy Machinery", image: IMG.heavyMachinery, desc: "Used industrial machinery from decommissioned plants." },
      { id: "industrial-generators", name: "Industrial Generators", image: IMG.generator, desc: "Diesel and gas gensets for reuse or recycling." },
      { id: "eot-crane", name: "EOT Crane", image: IMG.eotCrane, desc: "Electric Overhead Travelling cranes recovered from plants." },
      { id: "gantry-crane", name: "Gantry Crane", image: IMG.gantryCrane, desc: "Rail-mounted gantry cranes for yards and ports." },
      { id: "wharf-crane", name: "Wharf Crane", image: IMG.wharfCrane, desc: "Wharf and jetty cranes for container handling.", fit: "contain" },
    ],
  },
];

export const ALL_PRODUCTS = PRODUCT_CATEGORIES.flatMap(c =>
  c.products.map(p => ({ ...p, categoryId: c.id, categoryName: c.name }))
);
